// src/components/settings/settings-button.ts
import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'
import { SettingsModal } from './settings-modal'

@customElement('settings-button')
export class SettingsButton extends LitElement {
    static styles = css`
        :host {
            display: inline-block;
        }

        button {
            background: none;
            border: none;
            cursor: pointer;
            padding: var(--s-1);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: background-color var(--transition-fast, 0.15s);
            width: var(--control-height);
            height: var(--control-height);
        }

        button:hover {
            background-color: var(--color-bg-tertiary);
        }

        svg {
            width: 100%;
            height: 100%;
            fill: var(--primary-color);
        }
    `

    private _handleClick() {
        // Find or create the settings modal
        let modal = document.querySelector('settings-modal') as SettingsModal
        if (!modal) {
            modal = document.createElement('settings-modal') as SettingsModal
            document.body.appendChild(modal)

            // Add settings panel to the modal
            const panel = document.createElement('settings-panel')
            modal.appendChild(panel)
        }

        // Open the modal
        modal.open = true

        // Dispatch a click event
        this.dispatchEvent(
            new CustomEvent('click', {
                bubbles: true,
                composed: true,
            }),
        )
    }

    render() {
        return html`
            <button @click="${this._handleClick}" aria-label="Settings">
                <svg viewBox="0 0 24 24">
                    <path
                        d="M12 15.5c1.93 0 3.5-1.57 3.5-3.5S13.93 8.5 12 8.5 8.5 10.07 8.5 12s1.57 3.5 3.5 3.5zm0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"
                    />
                    <path
                        d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65z"
                    />
                </svg>
            </button>
        `
    }
}
